var React = require('react');

function OmbreMEC (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #6fa5c9;\n        opacity: 0.5;\n      }\n    ")),React.createElement("ellipse",{"id":"ombreMEC","className":"cls-1","cx":"79","cy":"4.5","rx":"79","ry":"4.5","key":1})]);
}

OmbreMEC.defaultProps = {"width":"158","height":"9","viewBox":"0 0 158 9"};

module.exports = OmbreMEC;

OmbreMEC.default = OmbreMEC;
